export const FIELD_TYPES = {
  text: {
    label: 'Text Input',
    icon: '🔤',
    description: 'Single line text input',
    supportsOptions: false
  },
  email: {
    label: 'Email Input',
    icon: '@',
    description: 'Email address input with validation',
    supportsOptions: false
  },
  number: {
    label: 'Number Input',
    icon: '#',
    description: 'Numeric input field',
    supportsOptions: false
  },
  password: {
    label: 'Password Input',
    icon: '🔒',
    description: 'Password input field',
    supportsOptions: false
  },
  url: {
    label: 'URL Input',
    icon: '🔗',
    description: 'URL input field',
    supportsOptions: false
  },
  tel: {
    label: 'Phone Input',
    icon: '📞',
    description: 'Telephone number input',
    supportsOptions: false
  },
  search: {
    label: 'Search Input',
    icon: '🔍',
    description: 'Search input field',
    supportsOptions: false
  },
  textarea: {
    label: 'Text Area',
    icon: '📄',
    description: 'Multi-line text input',
    supportsOptions: false
  },
  select: {
    label: 'Dropdown',
    icon: '⬇️',
    description: 'Single-select dropdown menu',
    supportsOptions: true
  },
  radio: {
    label: 'Radio Buttons',
    icon: '◉',
    description: 'Single-select radio buttons',
    supportsOptions: true
  },
  checkbox: {
    label: 'Checkboxes',
    icon: '☑️',
    description: 'Multi-select checkboxes',
    supportsOptions: true
  },
  switch: {
    label: 'Switch',
    icon: '🔘',
    description: 'Toggle switch (on/off)',
    supportsOptions: false
  },
  date: {
    label: 'Date Picker',
    icon: '📅',
    description: 'Date selection input',
    supportsOptions: false
  },
  time: {
    label: 'Time Picker',
    icon: '🕐',
    description: 'Time selection input',
    supportsOptions: false
  },
  'datetime-local': {
    label: 'Date & Time',
    icon: '🗓️',
    description: 'Date and time selection',
    supportsOptions: false
  },
  month: {
    label: 'Month Picker',
    icon: '📆',
    description: 'Month and year selection',
    supportsOptions: false
  },
  week: {
    label: 'Week Picker',
    icon: '📊',
    description: 'Week selection',
    supportsOptions: false
  },
  file: {
    label: 'File Upload',
    icon: '📎',
    description: 'File upload input',
    supportsOptions: false
  },
  attachment: {
    label: 'Attachment',
    icon: '📎',
    description: 'Multiple file upload',
    supportsOptions: false
  },
  image: {
    label: 'Image Upload',
    icon: '🖼️',
    description: 'Image file upload',
    supportsOptions: false
  },
  range: {
    label: 'Range Slider',
    icon: '🎚️',
    description: 'Range/slider input',
    supportsOptions: false
  },
  // color: {
  //   label: 'Color Picker',
  //   icon: '🎨',
  //   description: 'Color selection input',
  //   supportsOptions: false,
  // },
  rating: {
    label: 'Rating',
    icon: '⭐',
    description: 'Star rating input',
    supportsOptions: false
  },
  repeater: {
    label: 'Repeatable',
    icon: '🔁',
    description: 'Repeatable field group',
    supportsOptions: false
  },
  signature: {
    label: 'Signature',
    icon: '✍️',
    description: 'Digital signature pad',
    supportsOptions: false
  },
  divider: {
    label: 'Divider',
    icon: '➖',
    description: 'Visual divider/separator',
    supportsOptions: false
  },
  heading: {
    label: 'Heading',
    icon: 'H',
    description: 'Section heading text',
    supportsOptions: false
  },
  paragraph: {
    label: 'Paragraph',
    icon: '¶',
    description: 'Descriptive text paragraph',
    supportsOptions: false
  },
  hidden: {
    label: 'Hidden Field',
    icon: '👁️‍🗨️',
    description: 'Hidden input field',
    supportsOptions: false
  },
  currency: {
    label: 'Currency',
    icon: '💰',
    description: 'Currency selectbox',
    supportsOptions: false
  },
  price: {
    label: 'Price',
    icon: '💵',
    description: 'Price input with currency selectbox (number on left, currency on right)',
    supportsOptions: false
  },
  tags: {
    label: 'Tags',
    icon: '🏷️',
    description: 'Tag input (add/remove tags)',
    supportsOptions: false
  },
  tabs: {
    label: 'Tabs',
    icon: '📋',
    description: 'Tab container for grouping fields',
    supportsOptions: false
  }
};
export const getFieldTypeOptions = () => {
  return Object.entries(FIELD_TYPES).map(_ref => {
    let [key, type] = _ref;
    return {
      value: key,
      label: type.label,
      icon: type.icon
    };
  });
};
export const getFieldType = type => {
  return FIELD_TYPES[type] || FIELD_TYPES.text;
};